import React, { useEffect, useState } from 'react';
import Cleave from 'cleave.js/react';
import moment from 'moment';
import styles from './DateField.module.css';
import { ReactComponent as CalendarIcon } from '../../../assets/images/calendar.svg';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
// import { useMediaQuery } from 'react-responsive'; // Commenting this line because have seen date picker issue used in mobile screens
// So commenting above line will result in, Same date picker will be used in all screens.

const DateField = ({
    onDateChange = () => {},
    name,
    showError,
    minDate,
    maxDate,
    noPlaceholder = false,
    calendarMargin = true,
    required = false,
    resetDate = false,
    disabled = false
}) => {
    const [selectedDate, setSelectedDate] = useState();
    const [showCalendar, setShowCalendar] = useState(false);
    const [tempDate, setTempDate] = useState();
    const [isUSA, setIsUSA] = useState(true);

    // const isMobile = useMediaQuery({query: '(max-width: 640px)'}) //Commenting this line because have seen date picker issue used in
    // mobile screens. So commenting above line will result in, Same date picker will be used in all screens.

    const isMobile = true;
    const usaDateFormat = { string: 'MM/DD/YYYY', pattern: ['m', 'd', 'Y'] };
    const foreignDateFormat = { string: 'DD/MM/YYYY', pattern: ['d', 'm', 'Y'] };
    const dateFormat = isUSA ? usaDateFormat : foreignDateFormat;

    const toggleCalendar = () => {
        setShowCalendar(!showCalendar);
    };

    const handleCalendarDate = (e) => {
        const date = moment(e).format('MM/DD/YYYY');
        onDateChange(date);

        setTempDate(moment(date).format(dateFormat.string)); //for display in Cleave field only
        setSelectedDate(e);
        setShowCalendar(false);
    };

    const handleCleaveDate = (e) => {
        let cleaveDate = e.target.value;
        let date = new Date(cleaveDate);
        if (!cleaveDate) {
            onDateChange('');
        } else {
            onDateChange(date);
        }

        if (!isNaN(date.getTime())) {
            setTempDate(cleaveDate);
            setSelectedDate(date);
        } else {
            setTempDate(cleaveDate);
        }

        const dateRegex = new RegExp(/^(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d$/);
        if (dateRegex.test(cleaveDate)) {
            setShowCalendar(false);
        }
    };

    useEffect(() => {
        if (resetDate) {
            setTempDate('');
            setSelectedDate('');
        }
    }, [resetDate]);

    return (
        <div className={`datePicker ${styles.inputWrap} ${disabled && styles.disabled}`}>
            {isMobile ? (
                <>
                    <Cleave
                        onFocus={() => setShowCalendar(true)}
                        className={styles.dateInput}
                        name={name}
                        id={`${name}Input`}
                        placeholder={noPlaceholder ? '' : dateFormat.string.toLowerCase()}
                        value={tempDate}
                        onChange={handleCleaveDate}
                        disabled={disabled}
                        options={{
                            date: true,
                            delimiter: '/',
                            datePattern: dateFormat.pattern,
                            dateMax: moment().format('YYYY-MM-DD')
                        }}
                    />
                    <CalendarIcon
                        className={`ml-3 ${styles.calendarIcon}`}
                        onClick={toggleCalendar}
                    />
                    {showCalendar && (
                        <Calendar
                            className={`${styles.calendar} ${!calendarMargin && 'mt-0'}`}
                            name='incidentDate'
                            autocomplete='off'
                            value={selectedDate}
                            onChange={handleCalendarDate}
                            minDate={minDate || new Date(new Date().setFullYear(new Date().getFullYear() - 1))}
                            maxDate={maxDate || new Date()}
                        />
                    )}
                </>
            ) : (
                <input
                    type='date'
                    className={'form-control'}
                    defaultValue=''
                    name={name}
                    id={`${name}Input`}
                    value={tempDate}
                    onChange={handleCleaveDate}
                    required={required}
                    max={moment().format('YYYY-MM-DD')}
                    min={moment(new Date().setFullYear(new Date().getFullYear() - 1)).format('YYYY-MM-DD')}
                />
            )}
            {showError && <p className='error-msg'>Select a date to continue</p>}
        </div>
    );
};

export default DateField;
